<template>
  <div>
    <datatable
      :unique_buttons="unique_buttons"
      :show_load_ghana_flags_button="true"
      :is_createable="false"
      :show_delete="false"
      @thFilter="thFilter"
      @generate_offers="generateOffers"
      @edit_click="editClick"
      @cv="clickedCV"
      @cv_other="clickedCvOther"
      @internal_notes="clickedInternalNotes"
      @advanced_statuses="advancedStatuses"
      @applicant_modal_hover="applicantModalHover"
      @applicant_modal_leave="applicantModalLeave"
      @send_whatsapp="sendWhatsapp"
      @reject_offer="rejectOffer"
      @expose_offer="exposeOffer"
      @send_history="sendHistory"
      @ai_evaluate="aiEvaluate"
      title="Applicant Offers"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :show_header_filter="false"
      @score="score"
      @method_text="methodText"
      @method_1="methodOne"
      @method_2="methodTwo"
      @method_3="methodThree"
      @method_4="methodFour"
      @method_5="methodFive"
      @method_10="methodTen"
      :response="data"
      :operations="operations"
      :working_th_searches="working_th_searches"
      :pageTitleAdditionData="{showWhatsApp: true}"
    >
    </datatable>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
import cvOtherMixin from '@/mixins/cvOtherMixin.js'
export default {
  mixins: [cvOtherMixin],
  name: 'applicant-offers',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      search_company_results: [],
      offers_helper: new OffersHelper(),
      filters_helper,
      search_position: '',
      fields: [
        {
          name: 'status',
          value: 'status.name',
          component: 'OfferStatus'
        },
        {
          name: 'filters_message',
          value: 'filters_message'
        },
        {
          name: 'distance',
          value: 'distance',
          component: 'OfferDistance'
        },
        {
          name: 'position_title',
          component: 'TableCellPositionTitle',
          component_data_path: 'position',
          additional_data: {
            applicant: this.applicantData
          }
        },
        {
          name: 'offer_message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/offers/',
            headers: 'admin_headers',
            resource_type: 'Offer'
          }
        },
        {
          name: 'skills',
          value: 'position.positions_skills',
          component: 'DisplaySkills'
        },
        {
          name: 'position_message',
          value: 'position.message'
        },
        {
          name: 'company_name',
          component_data_path: 'position.company',
          component: 'LinkEntity'
        },
        {
          name: 'offers',
          component: 'GhanaFlag',
          component_data_path: 'position',
          additional_data: { resource_type: 'Position' }
        },
        {
          name: 'position_status',
          value: 'position.status'
        },
        {
          name: 'last_login',
          value: 'applicant.last_login',
          is_time: true
        },
        {
          name: 'sent_at',
          value: 'sent_at',
          is_time: true
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'score',
          value: 'score'
        },
        {
          name: 'score_info',
          value: 'score_info'
        }
      ],
      filters: [
        {
          type: 'input',
          designator: 'company_id',
          component: 'SearchCompanies'
        },
        {
          type: 'input',
          designator: 'position_title',
          placeholder: 'Position',
          class: this.$route.query.animation == 'TRUE' ? 'pulse_animation_1' : ''
        },
        {
          type: 'modal',
          designator: 'statuses',
          options: this.getFiltersOptions
        },
        {
          type: 'modal',
          designator: 'skills_exact',
          options: this.dropdownFeaturedSkills
        },
        {
          type: 'modal',
          designator: 'skills',
          options: this.dropdownSkills,
          class: this.$route.query.m == '2' ? 'pulse_animation_1' : '',
          searchable: true
        },
        {
          type: 'modal',
          designator: 'one_applicant_job_titles',
          options: this.singleDropdownJobTitles
        },
        {
          type: 'single',
          designator: 'is_hot_positions',
          options: [
            {
              text: 'true',
              value: true
            },
            {
              text: 'false',
              value: false
            }
          ]
        },
        {
          type: 'single',
          designator: 'near_train',
          options: [
            {
              text: 'true',
              value: true
            },
            {
              text: 'false',
              value: false
            }
          ]
        },
        {
          type: 'single',
          designator: 'position_status',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'standby',
              value: 'standby'
            },
            {
              text: 'blocked',
              value: 'blocked'
            },
            {
              text: 'expired',
              value: 'expired'
            },
            {
              text: 'editing',
              value: 'editing'
            },
            {
              text: 'fulfilled',
              value: 'fulfilled'
            },
            {
              text: 'deleted',
              value: 'deleted'
            },
            {
              text: 'test',
              value: 'test'
            }
          ]
        },
        {
          type: 'range',
          designator: 'max_distance'
        },
        {
          type: 'range',
          designator: 'max_salary_expectations',
          minValue: '5000',
          maxValue: '100000'
        },
        {
          type: 'modal',
          designator: 'office_size',
          options: [],
          class: this.$route.query.m == '3' ? 'pulse_animation_2' : ''
        },
        {
          type: 'modal',
          designator: 'seniority',
          options: []
        },
        {
          type: 'modal',
          subType: 'min-max-experience',
          designator: 'min_max_experience',
          splitter: '|'
        },
        {
          type: 'modal',
          subType: 'min-max-seniority',
          designator: 'min_max_seniority',
          splitter: '|'
        }
      ],
      sorters: [
        {
          designator: '',
          value: ''
        },
        {
          designator: 'sent_at',
          value: '-sent_at'
        },
        {
          designator: 'applicant_submitted_at',
          value: '-applicant_submitted_at'
        },
        {
          designator: 'created_at',
          value: '-created_at'
        },
        {
          designator: '+distance',
          value: 'distance'
        },
        {
          designator: '+score',
          value: 'score'
        },
        {
          designator: 'score',
          value: '-score'
        }
      ],
      data: [],
      unique_buttons: [
        { name: 'generate_offers', display_text: 'Generate Offers' },
        { name: 'score', display_text: 'Score' },
        { component: 'ScoreThisPage', payload: { d: this.getQueryParams, c: this.getCounters, type: 'Applicant', id: this.$route.query.applicant_id } },
        { name: 'advanced_statuses', display_text: 'Advanced Statuses' },
        { name: 'method_1', display_text: 'Method #1', css_classes: { 'is-info': () => this.$route.query.m == '1' } },
        { name: 'method_2', applicantId: this.$route.query.applicant_id, component: 'DataTableMethodTwo', css_classes: { 'is-info': () => this.$route.query.m == '2' } },
        { name: 'method_text', display_text: 'Texts', css_classes: { 'is-info': () => this.$route.query.m == 'text' } },
        { name: 'method_3', display_text: 'Method #3', css_classes: { 'is-info': () => this.$route.query.m == '3' } },
        { name: 'method_4', display_text: 'Method #4', css_classes: { 'is-info': () => this.$route.query.m == '4' } },
        { name: 'method_5', display_text: 'Method #5', css_classes: { 'is-info': () => this.$route.query.m == '5' } },
        { name: 'method_10', display_text: 'Method #10', css_classes: { 'is-info': () => this.$route.query.m == '10' } }
      ],
      operations: [
        { component: 'Preview', additional_data: { resource_type: 'Offer' } },
        { name: 'CV' },
        { name: 'cv_other', title: 'CV Other' },
        { name: 'reject_offer', icon: '/black_x.png' },
        { name: 'internal_notes', icon: '/note.png' },
        { name: 'send_whatsapp', title: 'Send Offer WA' },
        { name: 'applicant_modal', icon: '/applicant_modal.png' },
        {
          component: 'BoosterButton',
          additional_data: { resource_type: 'Offer' }
        },
        {
          component: 'ButtonEvaluate',
          additional_data: { resource_type: 'Offer' }
        },
        {
          component: 'OfferConversationButton',
          additional_data: { resource_type: 'Offer' }
        },
        { name: 'expose_offer', title: 'expose' },
        { name: 'ai_evaluate', title: 'AI' },
        { name: 'send_history', title: 'שליחות' }
      ],
      applicant_id: this.$route.query.applicant_id,
      applicantData: null,
      th_filters: [],
      counters: [],
      working_th_searches: ['company_name', 'position_title', 'owner']
    }
  },
  computed: {
    ...mapGetters('modals', ['isModalOpen', 'findModal']),
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('skills', ['dropdownFeaturedSkills', 'dropdownSkills']),
    ...mapGetters('jobTitles', ['singleDropdownJobTitles']),
    ...mapGetters('offerStatuses', ['getFiltersOptions', 'getAdvancedStatuses', 'getStarStatuses'])
  },
  watch: {
    dropdownAdmins (newValue) {
      this.watchTreeShaking(newValue, 'owner')
    },
    singleDropdownJobTitles (newValue) {
      this.watchTreeShaking(newValue, 'one_applicant_job_titles')
    },
    dropdownFeaturedSkills (newValue) {
      this.watchTreeShaking(newValue, 'skills_exact')
    },
    dropdownSkills (newValue) {
      this.watchTreeShaking(newValue, 'skills')
    },
    getFiltersOptions (newValue) {
      this.watchTreeShaking(newValue, 'statuses')
    }
  },
  async created () {
    this.applicantData = await this.$network_utils.getApplicant({ id: this.applicant_id })
    this.applicantJobTitles = await this.$network_utils.getApplicantJobTitle({ applicant_id: this.applicant_id })
    this.init()
    this.fetchAll()
    this.fetchAllSkills()
    this.watchTreeShaking(this.getFiltersOptions, 'statuses')
    this.watchTreeShaking(this.singleDropdownJobTitles, 'one_applicant_job_titles')
  },
  methods: {
    init () {
      this.getOffers()
      this.getQuestionsFilters()
    },
    watchTreeShaking (newValue, designator) {
      this.filters.forEach(filter => {
        if (filter.designator == designator) {
          filter.options = newValue
        }
      })
    },
    sendWhatsapp (data) {
      this.create({
        designator: 'whatsapp-conversation-modal',
        component_name: 'ModalWhatsappMessager',
        modal_title: 'Conversation',
        props: {
          applicant: data.applicant,
          offer: data
        }
      })
    },
    getOffers () {
      const query = this.getQueryParams()
      this.$network_utils
        .getResourceOffers(query)
        .then(response => {
          let data = []
          for (let i = 0; i < response.length; i++) {
            let offer = response[i]
            offer.applicant_name = offer.applicant.first_name + ' ' + offer.applicant.last_name
            offer.positions_skills = offer.position.positions_skills
            data.push(offer)
          }
          this.data = data.sort((a, b) => {
            return (b.position.is_hot - a.position.is_hot) || (b.created_at - a.created_at)
          })
          this.getCounters().then(response => {
            this.counters.push({
              name: 'result-counter',
              label: 'Result counter',
              value: response
            })
          })
        })
    },
    getCounters () {
      const query = this.getQueryParams()
      return this.$network_utils
        .getResourceOffers({
          ...query,
          count_only: true,
          per: undefined,
          page: undefined
        })
    },
    getQueryParams () {
      const dataExperience = this.$route.query['min_max_experience'] ? this.$route.query['min_max_experience'].split('|') : []
      const dataSeniority = this.$route.query['min_max_seniority'] ? this.$route.query['min_max_seniority'].split('|') : []
      return {
        resource_type: 'Applicant',
        resource_id: this.applicant_id,
        ...this.filters_helper.getServerCallFilters(this.filters),
        sort: this.$route.query.sort || '-applicant_submitted_at',
        per: 100,
        page: this.$route.query.page || 1,
        company_id: this.$route.query.company_id,
        position_title: this.$route.query.position_title,
        max_salary_expectations: this.$route.query.max_salary_expectations,
        min_experience: dataExperience[0],
        max_experience: dataExperience[1],
        min_seniority: dataSeniority[0],
        max_seniority: dataSeniority[1],
        ...this.th_filters
      }
    },
    getQuestionsFilters () {
      this.$network_utils.getQuestions({ designators: 'certification_date,seniority,job_title,office_size', current_resource_id: 1, current_type: 'Applicant' }).then(response => {
        response.forEach(question => {
          question = this.getQuestionWithSortedOptions(question)
          this.addQuestionOptionsToFilters(question)
        })
        this.$forceUpdate()
      })
    },
    getQuestionWithSortedOptions (question) {
      question.options.sort((a, b) => b.option_order - a.option_order)
      return question
    },
    addQuestionOptionsToFilters (question) {
      let filter_options = question.options.map(option => {
        if (question.designator == 'certification_date') {
          return { text: option.text, value: option.text }
        }
        return { text: option.text, value: option.id.toString() }
      })
      this.filters = this.filters.map(filter => {
        if (filter.designator == question.designator) {
          return { ...filter, options: filter_options }
        }
        return filter
      })
    },
    methodText () {
      this.$router.push({ name: this.$route.name, query: { m: 'text', applicant_id: this.applicant_id, is_hot_positions: 'true', sort: 'distance', animation: 'TRUE' } })
    },
    methodOne () {
      this.$router.push({ name: this.$route.name, query: { m: 1, applicant_id: this.applicant_id, statuses: 'awaiting_company, system_strong, awaiting_applicant_strong', sort: 'distance' } })
    },
    methodTwo () {
      this.$router.push({ name: this.$route.name, query: { m: 2, applicant_id: this.applicant_id, sort: 'distance' } })
    },
    methodThree () {
      this.$router.push({ name: this.$route.name, query: { m: 3, applicant_id: this.applicant_id, is_hot_positions: 'true', sort: 'distance' } })
    },
    methodFour () {
      this.$router.push({ name: this.$route.name, query: { m: 4, applicant_id: this.applicant_id, is_hot_positions: 'true', statuses: 'awaiting_admin', sort: 'distance' } })
    },
    methodFive () {
      this.$router.push({ name: this.$route.name, query: { m: 5, applicant_id: this.applicant_id, is_hot_positions: 'true', sort: 'distance' } })
    },
    methodTen () {
      const applicantJobTitleIds = this.applicantJobTitles.map(j => j.job_title.id).join(',')
      this.$router.push({ name: this.$route.name, query: { m: 10, applicant_id: this.applicant_id, max_salary_expectations: this.applicantData.min_salary_expectations, one_applicant_job_titles: applicantJobTitleIds, sort: 'distance' } })
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getOffers()
    },
    rejectOffer (data) {
      this.create({
        designator: 'reject-offer-modal-reason',
        component_name: 'MessageForm',
        resource_data: data,
        is_submitable: true,
        triggerBtn: true,
        additional_data: { endpoint: '/offers/', headers: 'admin_headers', resource_type: 'Offer' },
        modal_title: 'Reason for reject offer',
        props: {
          label: 'נא לפרט סיבה',
          parent: 'applicant',
          onSubmit: id => {
            this.offers_helper.rejectOffer(data)
            this.removeModalById(id)
          }
        }
      })
    },
    advancedStatuses () {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, statuses: this.getAdvancedStatuses } })
    },
    score () {
      this.$network_utils.postEvent({
        event: 'resource_score',
        current_type: 'Applicant',
        current_resource_id: this.applicant_id
      }).then(response => {
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      })
    },
    clickedCV (data) {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Offer', resource_id: data.id, modal_title: 'הערות פנימיות' })
    },
    applicantModalHover (data) {
      this.create({
        designator: 'applicant-info-modal',
        component_name: 'ApplicantInfo',
        resource_type: 'Applicant',
        resource_id: this.applicant_id,
        modal_open_action: 'no-click',
        override_modal_x: 500,
        modal_title: data.applicant.first_name + ' ' + data.applicant.last_name + this.$utils.getVetted(data.applicant),
        data: data.applicant
      })
    },
    applicantModalLeave () {
      let position_info_modal = this.findModal({ type: 'designator', value: 'applicant-info-modal' })
      this.remove(position_info_modal)
    },
    generateOffers (data) {
      this.$network_utils.postEvent({ event: 'resource_updated', current_type: 'Applicant', current_resource_id: this.applicant_id, current_applicant_id: this.applicant_id, sidekiq_queue: 'high' })
        .then(() => {
          this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
        })
    },
    editClick (data) {
      this.create({ designator: 'applicant-offers-form-modal', component_name: 'ApplicantOffersForm', data, applicant_id: this.applicant_id, modal_title: 'Edit Offer' })
    },
    aiEvaluate (data) {
      this.create({
        designator: 'ai-evaluation-modal-' + data.id,
        component_name: 'AiEvaluationModal',
        data,
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },
    exposeOffer (data) {
      this.create({
        designator: 'offer-exposure-preparation-modal',
        component_name: 'OfferExposurePreparationModal',
        modal_title: 'הכנה לחשיפת הצעה',
        modal_width: 900,
        props: {
          offer: data
        }
      })
    },
    sendHistory (data) {
      this.create({
        designator: 'cv_send_history',
        component_name: 'CvSendHistoryModal',
        modal_title: 'היסטוריית שליחות',
        modal_width: 900,
        is_center_modal: true,
        props: { offer: data }
      })
    },
    ...mapMutations('modals', ['update', 'create', 'remove', 'removeModalById']),
    ...mapActions('admins', ['fetchAll']),
    ...mapActions('skills', ['fetchAllSkills'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
